import MedboxHue from './components/medbox-hue';

interface IProps {
    menuHeight: number;
}
const UserMedbox = (props: IProps) => {
    return <MedboxHue {...props} />;
};

export default UserMedbox;
